import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { LOGO_RAIZES_WHITE } from '../lib/branding';

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#1A4D2E] relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />

      <div className="relative z-10 text-center px-6 max-w-lg w-full">
        {/* Ministério Raízes logo */}
        <div className="mb-8">
          <img 
            src={LOGO_RAIZES_WHITE}
            alt="Ministério Raízes"
            data-testid="logo-raizes"
            className="h-28 mx-auto drop-shadow-2xl"
          />
        </div>
        
        <p className="font-inter text-base text-white/80 mb-12 leading-relaxed">
          Acompanhe o crescimento espiritual das crianças
          <br />com carinho e organização
        </p>
        
        <div className="space-y-4 max-w-sm mx-auto">
          <Button
            data-testid="admin-button"
            onClick={() => navigate('/login')}
            className="w-full bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/20 rounded-full px-8 py-6 text-lg font-semibold shadow-lg active:scale-95 transition-all duration-300 flex items-center justify-center gap-3"
          >
            <Shield className="w-5 h-5" />
            Area Administrativa
          </Button>

          <Button
            data-testid="parent-button"
            onClick={() => navigate('/app-pais/login')}
            className="w-full bg-[#F4D35E] hover:bg-[#e5c44f] text-[#1A4D2E] rounded-full px-8 py-6 text-lg font-bold shadow-lg active:scale-95 transition-all duration-300 flex items-center justify-center gap-3"
          >
            <Users className="w-5 h-5" />
            Sou Pai/Mae
          </Button>
        </div>

        <p className="font-inter text-sm text-white/50 mt-10">
          Selecione o tipo de acesso
        </p>
      </div>
    </div>
  );
};

export default Welcome;
